<h2 mat-dialog-title class="text-lg font-bold mb-1">Rutas de vehículo {{ data.vehicleName }}</h2>

<mat-dialog-content class="modal-content">
  @if (dataSource.length === 0) {
    <div class="flex flex-col items-center justify-center p-8 text-gray-500">
      <mat-icon class="!text-5xl !w-12 !h-12 mb-2">route</mat-icon>
      <p>Este vehículo no tiene rutas asignadas</p>
    </div>
  } @else {
    <div class="overflow-auto max-h-96">
      <table mat-table [dataSource]="dataSource" class="w-full">

        <!-- Ruta Column -->
        <ng-container matColumnDef="route">
          <th mat-header-cell *matHeaderCellDef class="text-left">Ruta</th>
          <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
            <app-sub-route-navigation
              [route]="{ routeCode: element.subRouteCode, routeName: element.nameSubRoute }"
              displayMode="both"
              [showIcon]="true"
              interactionMode="icon-only"
              [openInNewTab]="true"
            />
          </td>
        </ng-container>

        <!-- Territorios Column -->
        <ng-container matColumnDef="territory">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Territorios</th>
          <td mat-cell *matCellDef="let element">
            <div class="text-sm">
              @if (getTerritoriesRoutes(element).length > 0) {
                <div class="flex flex-wrap gap-1">
                  @for (territory of visibleTerritories(element); track territory._id) {
                    <span class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                      <mat-icon class="!w-3 !h-3 !text-[12px]">location_on</mat-icon>
                      <span class="truncate">{{ territory.externalKeys?.code ? (territory.externalKeys.code + ' - ' + territory.name) : territory.name }}</span>
                      <app-route-navigation
                        [route]="territory"
                        [showText]="false"
                        [showIcon]="true"
                        interactionMode="icon-only"
                        [openInNewTab]="true"
                      />
                    </span>
                  }
                  @if (hiddenTerritoriesCount(element) > 0) {
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                      +{{ hiddenTerritoriesCount(element) }}
                    </span>
                  }
                </div>
              } @else {
                <span class="text-gray-400">Sin territorios</span>
              }
            </div>
          </td>
        </ng-container>

        <!-- Oficina de Venta Column -->
        <ng-container matColumnDef="saleOffice">
          <th mat-header-cell *matHeaderCellDef class="text-left">Oficina de venta</th>
          <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
            <app-sales-office-navigation
              [data]="{ code: element.salesOfficeCode, name: element.salesOffice }"
              displayMode="both"
              [showIcon]="true"
              interactionMode="icon-only"
              [openInNewTab]="true"
            />
          </td>
        </ng-container>

        <!-- Usuario Asignado Column -->
        <ng-container matColumnDef="assignedUser">
          <th mat-header-cell *matHeaderCellDef class="text-left">Usuario asignado</th>
          <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
            <app-business-partner-navigation
              [businessPartner]="{ code: element.assignedUserCode, name: element.assignedUser }"
              displayMode="both"
              [showIcon]="true"
              interactionMode="icon-only"
              [openInNewTab]="true"
            />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="bg-gray-50"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
